import { render, staticRenderFns } from "./removeStudentLogList.vue?vue&type=template&id=133501ca"
import script from "./removeStudentLogList.vue?vue&type=script&lang=js"
export * from "./removeStudentLogList.vue?vue&type=script&lang=js"
import style0 from "./removeStudentLogList.vue?vue&type=style&index=0&id=133501ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports